import routes from './routes'
import { LobbyEntryProps, LobbyEntryTypes } from './components/LobbyEntry/LobbyEntry'

// backdrops
import Entrance from './images/backdrops/entrance.jpg'
import EntranceM from './images/backdrops/entranceM.jpg'
import Countdown from './images/backdrops/entrance.jpg'
import CountdownM from './images/backdrops/entranceM.jpg'
import LobbyL from './images/backdrops/lobby.jpg'
import LobbyM from './images/backdrops/space.jpg'
import Exhibition from './images/backdrops/exhibition.jpg'
import Auditorium from './images/backdrops/auditorium.jpg'
import AuditoriumM from './images/backdrops/auditoriumP.jpg'
import NetworkingL from './images/backdrops/networking.jpg'
import NetworkingM from './images/backdrops/networkingM.jpg'
import Gallerium from './images/backdrops/gallerium.jpg'

// audio
import LobbyMusic from './images/audio/lobby.mp3'

// icons & decorations
import InfoIcon from './images/lobbyEntry/infoIcon.png'
import ArrowIcon from './images/lobbyEntry/arrow.png'
import { GlobalModalTypes } from './components/GlobalModals/GlobalModalContainer'

const dev = {
  // apiUrl: 'http://localhost:3000',
  apiUrl: 'https://msh2022.herokuapp.com',
}

const prod = {
  apiUrl: 'https://msh2022.herokuapp.com',
}

const API_KEYS = {
  amplitude: 'fba1c8a36b0247269c9112c27c9c637b',
}

const VOLUME_VALUE = 0.1

// Root page will show either EntrancePage or CountdownPage
// based on the following time setting
const EVENT_START_TIME = {
  year: 2022,
  month: 8,
  day: 8,
  hour: 14,
  minute: 0,
}

const config = process.env.NODE_ENV === 'production' ? prod : dev

const assets = {
  entrance: {
    landscape: Entrance,
    portrait: EntranceM,
  },
  countdown: {
    landscape: Countdown,
    portrait: CountdownM,
  },
  lobby: {
    landscape: LobbyL,
    portrait: LobbyM,
  },
  auditorium1: {
    landscape: Auditorium,
    portrait: AuditoriumM,
  },

  exhibition1: Exhibition,
  exhibition2: Exhibition,

  networking: {
    landscape: NetworkingL,
    portrait: NetworkingM,
  },
  gallerium: Gallerium,

  lobbyMusic: LobbyMusic,
}

const layout = {
  auditoriumVid: `
    top: 9%;
    bottom: 28%;
    left: 10%;
    right: 33%;
  `,
}

const lobbyEntries: Array<LobbyEntryProps & { id: string }> = [
  {
    id: 'auditorium',
    type: LobbyEntryTypes.DirectRoute,
    destination: routes.programme,
    pinImage: ArrowIcon,
    css: `
      top: 66%;
      left: 29%;
      right: 61.5%;
      bottom: 24%;
    `,
  },
  {
    id: 'exhibition',
    type: LobbyEntryTypes.MultiRoutes,
    selectionTitle: 'Please select a hall:',
    destinations: [
      { name: 'Hall A', route: routes.exhibition1 },
      { name: 'Hall B', route: routes.exhibition2 },
      { name: 'Hall C', route: routes.exhibition3 },
    ],
    pinImage: ArrowIcon,
    css: `
      top: 66%;
      left: 60.8%;
      right: 29.8%;
      bottom: 24%;
    `,
  },
  {
    id: 'on-demand',
    type: LobbyEntryTypes.DirectRoute,
    destination: routes.onDemand,
    pinImage: ArrowIcon,
    css: `
      top: 46.5%;
      left: 24.7%;
      right: 68.6%;
      bottom: 47.8%;
    `,
  },
  {
    id: 'e-poster',
    type: LobbyEntryTypes.DirectRoute,
    destination: routes.onDemandPoster,
    pinImage: ArrowIcon,
    css: `
      top: 46.5%;
      left: 68.4%;
      right: 24.5%;
      bottom: 46.8%;
    `,
  },
  {
    id: 'helpdesk',
    type: LobbyEntryTypes.Helpdesk,
    pinImage: InfoIcon,
    css: `
      top: 80%;
      left: 25%;
      right: 77%;
      bottom: 25.5%;
    `,
  },
  {
    id: 'token-hunter',
    type: LobbyEntryTypes.GlobalModal,
    modalId: GlobalModalTypes.Game,
    pinImage: ArrowIcon,
    css: `
      top: 77%;
      left: 6.5%;
      right: 95.5%;
      bottom: 13%;
    `,
  },
  {
    id: 'meet-the-expert',
    // type: LobbyEntryTypes.ComingSoon,
    type: LobbyEntryTypes.DirectRoute,
    destination: routes.onDemandMTE,
    pinImage: ArrowIcon,
    css: `
      top: 77%;
      left: 92%;
      right: 7.5%;
      bottom: 13%;
    `,
  },
]

export default {
  API_KEYS,
  assets,
  layout,
  lobbyEntries,
  VOLUME_VALUE,
  EVENT_START_TIME,

  eventName: 'Malaysian Society of Haematology Scientific Meeting 2022',

  ...config,
}
